import { Link } from "react-router-dom";
import Breadcrumb from "@/components/feature/Breadcrumb";

const contentScope = [
  { icon: "ri-film-line", title: "全集剧情介绍", desc: "第 1 至 12 集的剧情摘要与详细文本，逐集梳理故事线。" },
  { icon: "ri-user-star-line", title: "角色档案", desc: "主要角色的定位、性格分析与出场集数索引。" },
  { icon: "ri-compass-3-line", title: "观看与解析指南", desc: "正版平台入口、观看顺序建议与深度解析文章。" },
];

const rules = [
  {
    icon: "ri-shield-check-line",
    title: "使用须知",
    desc: "本站为演示性质的内容站点，所展示的剧情与角色资料仅供学习交流使用，请以官方发布信息为准。",
  },
  {
    icon: "ri-lock-line",
    title: "隐私政策简述",
    desc: "本站不收集、不存储你的个人信息。收藏功能仅将数据保存在你本机浏览器中，清除浏览器数据后即会消失。",
  },
  {
    icon: "ri-copyright-line",
    title: "版权声明",
    desc: "《甜蜜惩罚》的名称、角色及相关素材版权归原作者与正版发行方所有。本站不存储影片资源，也不提供播放与下载。",
  },
];

export default function About() {
  return (
    <div className="space-y-6">
      <title>关于我们 - 甜蜜惩罚动漫</title>
      <meta
        name="description"
        content="了解甜蜜惩罚动漫网站：本站专注整理《甜蜜惩罚》的全集剧情、角色档案与观看指南，为动漫爱好者提供清晰可检索的内容，并说明版权、联系方式与隐私政策。"
      />
      <meta name="keywords" content="甜蜜惩罚动漫,关于甜蜜惩罚,甜蜜惩罚网站,甜蜜惩罚介绍" />
      <link rel="canonical" href="https://cloudschoolserver.cn/about" />

      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

      <header className="rounded-lg bg-primary-900 text-background-50 p-6 md:p-10">
        <span className="inline-flex w-fit items-center gap-1.5 px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-label mb-4">
          <i className="ri-information-line"></i> 关于本站
        </span>
        <h1 className="font-heading text-2xl md:text-3xl mb-4">一个专注《甜蜜惩罚》的资料站</h1>
        <p className="text-sm md:text-base text-primary-100 leading-loose font-label max-w-3xl">
          甜蜜惩罚动漫网站是一个面向动漫爱好者的内容门户，围绕《甜蜜惩罚》这部作品，
          系统整理了全集剧情、角色档案与观看指南。我们希望用清晰的结构、可检索的内容，
          帮助每一位观众快速找到自己想了解的那一段故事、那一个人物。
        </p>
      </header>

      <section>
        <h2 className="font-heading text-xl text-foreground-950 mb-4">内容范围</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {contentScope.map((item) => (
            <div key={item.title} className="rounded-lg bg-background-50 border border-background-200 p-5">
              <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-xl mb-3">
                <i className={item.icon}></i>
              </span>
              <h3 className="font-heading text-base text-foreground-950 mb-1.5">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed font-label">{item.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {rules.map((item) => (
          <div key={item.title} className="rounded-lg bg-background-50 border border-background-200 p-5">
            <h3 className="font-heading text-base text-foreground-950 mb-2 flex items-center gap-2">
              <i className={`${item.icon} text-primary-600`}></i>
              {item.title}
            </h3>
            <p className="text-sm text-foreground-600 leading-loose font-label">{item.desc}</p>
          </div>
        ))}
      </section>

      <section className="rounded-lg bg-accent-50 border border-accent-200 p-6 md:p-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <h2 className="font-heading text-xl text-foreground-950 mb-3 flex items-center gap-2">
              <i className="ri-customer-service-2-line text-accent-700"></i>联系方式
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed font-label mb-4">
              以下信息仅用于内容交流，欢迎指正资料疏漏或补充剧情细节。
            </p>
            <ul className="space-y-2.5 text-sm font-label text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-700"></i> hello@sweet-punishment-anime.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-wechat-line text-accent-700"></i> sweetpunishment_fans
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-music-2-line text-accent-700"></i> @sweetpunishment_anime
              </li>
            </ul>
          </div>
          <div className="flex flex-col justify-center">
            <p className="text-sm text-foreground-600 leading-loose font-label mb-4">
              想直接开始浏览？可以从全集剧情开始，也可以先看看大家最常关注的角色。
            </p>
            <div className="flex flex-wrap gap-3">
              <Link
                to="/episodes"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-label hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-film-line"></i> 浏览全集剧情
              </Link>
              <Link
                to="/characters"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-background-50 border border-background-300 text-foreground-800 text-sm font-label hover:border-primary-300 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-group-line"></i> 查看角色介绍
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}